import React from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faYoutube,
  faXTwitter,
  faThreads,
  faQuora,
  faReddit,
  faPinterest,
} from "@fortawesome/free-brands-svg-icons";
import { faListCheck } from "@fortawesome/free-solid-svg-icons";

const FONT = "'Host Grotesk', sans-serif";

const PLATFORM_COLORS = {
  facebook: "#1877f2",
  youtube:  "#ff0000",
  twitter:  "#181919",
  threads:  "#6633cc",
  all:      "#6366f1",
};

const platforms = [
  { value: "facebook",  label: "Facebook",  icon: faSquareFacebook },
  { value: "youtube",   label: "YouTube",   icon: faYoutube         },
  { value: "twitter",   label: "Twitter",   icon: faXTwitter        },
  { value: "threads",   label: "Threads",   icon: faThreads         },
  { value: "quora",     label: "Quora",     icon: faQuora           },
  { value: "reddit",    label: "Reddit",    icon: faReddit          },
  { value: "pinterest", label: "Pinterest", icon: faPinterest       },
  { value: "all",       label: "All",       icon: faListCheck       },
];

const PlatformDropdown = ({ selectedPlatform, handlePlatformClick }) => {
  const selected = platforms.find((p) => p.value === selectedPlatform);

  return (
    <FormControl sx={{ width: "100%" }} size="small">
      <InputLabel
        id="platform-dropdown-label"
        shrink
        sx={{
          fontFamily: FONT,
          fontSize: "13px",
          color: "#94a3b8",
          "&.Mui-focused": { color: "#6366f1" },
        }}
      >
        Platform
      </InputLabel>
      <Select
        labelId="platform-dropdown-label"
        label="Platform"
        value={selectedPlatform}
        onChange={(e) => handlePlatformClick(e.target.value)}
        displayEmpty
        renderValue={() => (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {selected && (
              <FontAwesomeIcon
                icon={selected.icon}
                style={{
                  fontSize: "14px",
                  color: PLATFORM_COLORS[selected.value] ?? "#6366f1",
                }}
              />
            )}
            <span style={{ fontFamily: FONT, fontSize: "13px", color: "#1e293b" }}>
              {selected?.label ?? "All"}
            </span>
          </div>
        )}
        sx={{
          height: "44px",
          borderRadius: "10px",
          fontFamily: FONT,
          fontSize: "13px",
          backgroundColor: "#ffffff",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#a5b4fc",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
            borderWidth: "1.5px",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.10)",
              border: "1px solid #e2e8f0",
              marginTop: "4px",
              fontFamily: FONT,
            },
          },
        }}
      >
        {platforms.map((platform) => {
          const isSelected = selectedPlatform === platform.value;
          return (
            <MenuItem
              key={platform.value}
              value={platform.value}
              sx={{
                fontFamily: FONT,
                fontSize: "13px",
                fontWeight: isSelected ? 600 : 400,
                borderRadius: "8px",
                mx: "4px",
                my: "2px",
                gap: "10px",
                color: isSelected ? PLATFORM_COLORS[platform.value] : "#374151",
                backgroundColor: isSelected
                  ? `${PLATFORM_COLORS[platform.value]}12`
                  : "transparent",
                "&:hover": {
                  backgroundColor: `${PLATFORM_COLORS[platform.value]}18`,
                  color: PLATFORM_COLORS[platform.value],
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 28 }}>
                <FontAwesomeIcon
                  icon={platform.icon}
                  style={{
                    fontSize: "15px",
                    color: isSelected ? PLATFORM_COLORS[platform.value] : "#94a3b8",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={platform.label}
                primaryTypographyProps={{
                  fontFamily: FONT,
                  fontSize: "13px",
                  fontWeight: isSelected ? 600 : 400,
                }}
              />
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default PlatformDropdown;